import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import { Box } from '@wix/design-system';
import { AppContextProvider } from '../../AppLoader';
import { GradientDivider } from './GradientDivider';
import { SendErrorSectionHelper } from './SendErrorSectionHelper';
import WixAppDeviceError from '../../../assets/images/wixAppDeviceError.svg';

/**
 * Body of the redesigned Confirm-Device "Error" screen (expired / declined /
 * error) — the error illustration, center-aligned..
 */
export const ConfirmErrorBody: React.FC = observer(() => {
  const {
    rootStore: {
      postLoginStore: {
        premiumUsers2FaEnforcementStore: { ownerAppStore: store },
      },
    },
  } = useContext(AppContextProvider);
  return (
    <Box direction="vertical" width="100%" gap={4} align="center">
      {store.showResendError && <SendErrorSectionHelper />}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <div style={{ overflow: 'hidden', height: 200, width: '100%' }}>
          <WixAppDeviceError
            width={275}
            style={{ display: 'block', margin: '0 auto' }}
          />
        </div>
        <GradientDivider />
      </div>
    </Box>
  );
});
